/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { setRegularityOptions } from '../store/options.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getRegularityOptions() {
  const serviceId = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const regularityOptions = yield call([vitalsService, vitalsService.getRegularityMethod])
    const { entity } = regularityOptions
    yield put(setRegularityOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getRegularityOptions() error: ${e}`))
  }
}

export function* getRegularityOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getRegularityOptions)
}
